import { Col, Row } from 'antd'
import {
  EditorContent,
  MainHeading,
  SecondGreyText,
  StyledP,
  SubFLex,
} from './style'
import moment from 'moment'
import React, { useEffect, useState } from 'react'
import { COLORS } from 'theme'
import { ExclamationCircleFilled } from '@ant-design/icons'
import styled from 'styled-components'

const PendingIcon = styled(ExclamationCircleFilled)`
  color: #eb5d60;
  font-size: 16px;
  margin-left: 8px;
`

const AdditionalInfo = ({ studentDetails, pendingData }) => {
  const splitArray = list => {
    return list?.toString()
  }
  const splitArrayLocation = list => {
    if (!Array.isArray(list)) return ''
    return list
      .map(item => (item?.city_name ? item?.city_name : item?.state_name))
      .join(', ')
  }

  const [listData, setListData] = useState([])
  const [profilePendingFields, setProfilePendingFields] = useState({})

  useEffect(() => {
    const approvedProfile = studentDetails?.studentPersonalProfile || {}
    const approvedAdmin = studentDetails?.admin || {}
    const pendingRequests = pendingData?.requests || []
    
    // Transform API pending data structure for personal profile fields
    const pendingFields = {}
    let hasPendingRequest = false
    
    pendingRequests.forEach(request => {
      if (!request.itemId && request.status === 'PENDING') {
        const fieldName = request.fieldName
        pendingFields[fieldName] = {
          value: request.requestedData,
          originalValue: request.originalData,
          status: request.status,
          _requestId: request.id
        }
        hasPendingRequest = true
      }
    })
    
    setProfilePendingFields(pendingFields)
    
    const hasFieldChanged = (fieldKey) => {
      return pendingFields[fieldKey] !== undefined
    }
    
    const getFieldValue = (fieldKey, approvedValue) => {
      if (pendingFields[fieldKey]) {
        return pendingFields[fieldKey].value
      }
      return approvedValue
    }
    
    const displayProfile = { ...approvedProfile }
    const displayAdmin = { ...approvedAdmin }
    
    // Apply pending values
    Object.keys(pendingFields).forEach(fieldKey => {
      const pendingValue = pendingFields[fieldKey].value
      
      // Handle address fields that might be objects with city/state names
      if (fieldKey === 'corrCity' || fieldKey === 'permCity') {
        displayProfile[fieldKey] = typeof pendingValue === 'object' ? pendingValue?.corrCity || pendingValue?.permCity : pendingValue
      } else if (fieldKey === 'corrState' || fieldKey === 'permState') {
        displayProfile[fieldKey] = typeof pendingValue === 'object' ? pendingValue?.corrState || pendingValue?.permState : pendingValue
      } else if (fieldKey === 'corrCountry' || fieldKey === 'permCountry') {
        displayProfile[fieldKey] = typeof pendingValue === 'object' ? pendingValue?.corrCountry || pendingValue?.permCountry : pendingValue
      } else if (fieldKey === 'dob' || fieldKey === 'gender') {
        displayAdmin[fieldKey] = pendingValue
      } else {
        displayProfile[fieldKey] = pendingValue
      }
    })
    
    let otherData = [
      {
        id: 1,
        name: 'Preferred Location',
        value: displayProfile?.isAnywhere
          ? 'Anywhere'
          : splitArrayLocation(displayProfile?.preferredJobLocation),
        isPending: hasFieldChanged('preferredJobLocation') || hasFieldChanged('isAnywhere'),
      },
      {
        id: 2,
        name: 'Gender',
        value: displayProfile?.gender?.replace(/_/g, ' ') || '',
        isPending: hasFieldChanged('gender'),
      },

      {
        id: 4,
        name: 'Date of Birth',
        value: (() => {
          const dob = displayProfile?.dob || displayAdmin?.dob
          return dob ? moment(dob).format('DD/MM/YYYY') : ''
        })(),
        isPending: hasFieldChanged('dob'),
      },
      {
        id: 5,
        name: 'Secondary Email ID',
        value: displayProfile?.secondaryEmail,
        isPending: hasFieldChanged('secondaryEmail'),
      },
      // {
      //   id: 6,
      //   name: 'Caste',
      //   value: studentDetails?.studentPersonalProfile?.caste,
      // },
      // {
      //   id: 7,
      //   name: 'Religion',
      //   value: studentDetails?.studentPersonalProfile?.religion,
      // },
      {
        id: 8,
        name: 'Language',
        value: splitArray(displayProfile?.languages),
        isPending: hasFieldChanged('languages'),
      },
      // {
      //   id: 9,
      //   name: 'Hobbies',
      //   value: splitArray(studentDetails?.studentPersonalProfile?.hobbies),
      // },
      {
        id: 10,
        name: 'Current Address',
        value: (
          <>
            {displayProfile?.corrAddrLine1}
            {displayProfile?.corrAddrLine1 && ','}
            {displayProfile?.corrAddrLine2}
            {displayProfile?.corrAddrLine2 && ','}
            {typeof displayProfile?.corrCity === 'object' ? displayProfile?.corrCity?.corrCity : displayProfile?.corrCity}
            {displayProfile?.corrCity && ','}
            {typeof displayProfile?.corrState === 'object' ? displayProfile?.corrState?.corrState : displayProfile?.corrState}
            {displayProfile?.corrState && ','}
            {typeof displayProfile?.corrCountry === 'object' ? displayProfile?.corrCountry?.corrCountry : displayProfile?.corrCountry}
            {displayProfile?.corrCountry && ','}
            {displayProfile?.corrPostCode}
          </>
        ),
        isPending: ['corrAddrLine1', 'corrAddrLine2', 'corrCity', 'corrState', 'corrCountry', 'corrPostCode'].some(field => 
          hasFieldChanged(field)
        ),
      },
      {
        id: 11,
        name: 'Permanent Address',
        value: (
          <>
            {displayProfile?.permAddrLine1}
            {displayProfile?.permAddrLine1 && ','}
            {displayProfile?.permAddrLine2}
            {displayProfile?.permAddrLine2 && ','}
            {typeof displayProfile?.permCity === 'object' ? displayProfile?.permCity?.permCity : displayProfile?.permCity}
            {displayProfile?.permCity && ','}
            {typeof displayProfile?.permState === 'object' ? displayProfile?.permState?.permState : displayProfile?.permState}
            {displayProfile?.permState && ','}
            {typeof displayProfile?.permCountry === 'object' ? displayProfile?.permCountry?.permCountry : displayProfile?.permCountry}
            {displayProfile?.permCountry && ','}
            {displayProfile?.permPostCode}
          </>
        ),
        isPending: ['permAddrLine1', 'permAddrLine2', 'permCity', 'permState', 'permCountry', 'permPostCode'].some(field => 
          hasFieldChanged(field)
        ),
      },
    ]
    setListData(otherData)
  }, [studentDetails, pendingData])
const cleanText = html => html?.replace(/<[^>]*>/g, '').trim()

  return (
    <SubFLex column gap="20px">
      {listData?.map((item, index) => (
        <Row style={{ width: '100%' }} key={index + 'list'}>
          <Col span={10}>
            <SecondGreyText color={COLORS.GREY_T_60}>
              {item?.name}
            </SecondGreyText>
          </Col>
          <Col span={2}>
            {' '}
            <SecondGreyText>-</SecondGreyText>{' '}
          </Col>
          <Col span={12}>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <SecondGreyText>{item?.value}</SecondGreyText>
              {item?.isPending && <PendingIcon />}
            </div>
          </Col>
        </Row>
      ))}

      {/* Extracurricular Activities */}
      {cleanText(studentDetails?.studentPersonalProfile?.extraCurriculars || profilePendingFields?.extraCurriculars?.value) && (
        <>
          <MainHeading marginBottom="5px" style={{ display: 'flex', alignItems: 'center' }}>
            Extracurricular Activities
            {profilePendingFields?.extraCurriculars !== undefined && <PendingIcon />}
          </MainHeading>
          <StyledP>
            <EditorContent
              dangerouslySetInnerHTML={{
                __html:
                  profilePendingFields?.extraCurriculars?.value ||
                  studentDetails?.studentPersonalProfile?.extraCurriculars || '',
              }}
            />
          </StyledP>
        </>
      )}
    </SubFLex>
  )
}

export default AdditionalInfo
